(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DailyCoinsReportViewModel', DailyCoinsReportViewModelFactory);

  /** @ngInject */
  function DailyCoinsReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {
    function DailyCoinsReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };
      this.chartType = 'TOKENS_TITLE';

      init.call(this);
    }

    DailyCoinsReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return DailyCoinsReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions.getTotalTokenCount(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }

  }
})();
